import api from './ApiService';
export async function PostCustomerService(params) {
  await api.post(`customer-form`, params);
  return true;
}
